import { mapState, mapActions, mapMutations } from 'vuex'
import ManufactureSelectForm from './components/manufacture-select-form/manufacture-select-form.vue'
import ManufactureSelectList from './components/manufacture-select-list/manufacture-select-list.vue'
import ShiftTable from './components/shift-table/shift-table.vue'
import CreateEncashmentModal from '@/components/modals/create-encashment-modal/create-encashment-modal.vue'
import ConfirmEncashmentModal from '@/components/modals/confirm-encashment-modal/confirm-encashment-modal.vue'
import ExchangeCashInStockModal from '@/components/modals/exchange-cash-in-stock-modal/exchange-cash-in-stock-modal.vue'
import IcEdit from '@/assets/svg/ic-edit.svg?inline'
import IcExit from '@/assets/svg/ic-exit.svg?inline'
import { superUsers } from '@/const'

const getDefaultExchange = () => ({
  in_stock: 0,
  on_route: 0,
  altogether: 0
})

const getDefaultManufactureDataset = () => ({
  selectedCity: null,
  selectedManufacture: null
})

export default {
  name: 'WelcomScreen',
  components: {
    ManufactureSelectForm,
    ManufactureSelectList,
    ShiftTable,
    CreateEncashmentModal,
    ConfirmEncashmentModal,
    ExchangeCashInStockModal,
    IcEdit,
    IcExit
  },
  static() {
    return {
      superUsers
    }
  },
  data() {
    return {
      welcomeScreen: null,
      isWasCancelEncashment: false,
      isWasCreateEncashment: false,
      exchange: getDefaultExchange(),
      selectedManufactureDataset: getDefaultManufactureDataset()
    }
  },
  computed: {
    ...mapState({
      user: state => state.users.user,
      cities: state => state.manufactures.cities,
      workshopsInfo: state => state.orders.workshopsInfo,
      finalEncashmentData: state => state.encashment.finalEncashmentData,
      finalEncashment: state => state.encashment.finalEncashment,
      selectedManufacture: state => state.manufactures.selectedManufacture,
      adminRoles: state => state.sharedData.adminRoles
    })
  },
  created() {
    this.clearRouteTasks()
  },
  mounted() {
    this.getAdminRoles()
    this.setWelcomeScreenData()
  },
  methods: {
    ...mapActions({
      getWelcomeScreen: 'users/getWelcomeScreen',
      logout: 'users/logout',
      getExchange: 'users/getExchange',
      startShift: 'users/startShift',
      getWorkshopsInfo: 'orders/getWorkshopsInfo',
      getCities: 'manufactures/getCities',
      createFinalEncashment: 'encashment/createFinalEncashment',
      cancelLastEncashment: 'encashment/cancelLastEncashment',
      updloadPhoto: 'users/updloadPhoto',
      getAdminRoles: 'sharedData/getAdminRoles',
      setSelectedCityAction: 'manufactures/setSelectedCity',

      setRemakeConnection: 'collectOrders/setRemakeConnection',
      clearRouteTasks: 'collectOrders/clearRouteTasks'
    }),
    ...mapMutations({
      setSelectedManufacture: 'manufactures/SET_SELECTED_MANUFACTURE',
      setLoading: 'pageLoader/SET_LOADING',
      setFinalEncashmentData: 'encashment/SET_FINAL_ENCASHMENT_DATA',
      setFinalEncashment: 'encashment/SET_FINAL_ENCASHMENT'
    }),
    async setWelcomeScreenData() {
      if (this.selectedManufacture) {
        this.$router.push({ name: 'main' })
      } else {
        this.welcomeScreen = await this.getWelcomeScreen()
        if (this.finalEncashmentData) {
          this.$nextTick(() => {
            this.$refs['create-encashment-modal'].show()
          })
        }
      }
    },
    /** 
     * @param {*} event 
     * { selectedCity, selectedManufacture }
     */
    async onSetManufactureData(event) {
      this.selectedManufactureDataset = event
      if (this.user.role === 'admin') {
        this.exchange = await this.getExchange(this.selectedManufactureDataset.selectedManufacture.id)
        this.$nextTick(() => {
          this.$refs['exchange-cash-in-stock-modal'].show()
        })
      } else {
        this.onSubmitManufacture()
      }
    },
    onCashInStockModalHide() {
      this.exchange = getDefaultExchange()
      this.selectedManufactureDataset = getDefaultManufactureDataset()
    },
    async onSubmitManufacture(exchangeCashInStock) {
      const { selectedCity, selectedManufacture } = this.selectedManufactureDataset
      this.setSelectedManufacture(selectedManufacture)
      this.setLoading(true)
      try {
        if (this.user.role === 'admin') {
          await this.startShift(exchangeCashInStock)
        }
        const promiseArr = [
          this.getWorkshopsInfo(),
          this.setRemakeConnection()
        ]

        if (this.superUsers.indexOf(this.user.role) !== -1) {
          promiseArr.push(this.getCities())
        }

        await Promise.all(promiseArr)

        /**
         * Поскольку cities в welcome-screen отличаются 
         * по структуре в запросе cities, поэтому для установки
         * правильного объекта, установим его после запроса getCities
         */
        if (this.superUsers.indexOf(this.user.role) !== -1) {
          const setedCity = this.cities.find(city => city.city_id === selectedCity.city_id)
          this.setSelectedCityAction(setedCity)
        }

        this.$router.replace({
          name: 'main'
        })
      } finally {
        this.$refs['exchange-cash-in-stock-modal'].hide()
        this.setLoading(false)
      }
    },
    async onCreateEncashment({ amount }) {
      await this.createFinalEncashment(amount)
      this.isWasCreateEncashment = true
      this.$nextTick(() => {
        this.$refs['confirm-encashment-modal'].show()
      })
    },
    onEncashmentModalHide() {
      if (!this.isWasCreateEncashment) {
        this.setFinalEncashmentData(null)
        this.setFinalEncashment(null)
      }
    },
    /**
     * здесь не через async await,
     * так как логика удаления finalEncashment
     * будет нарушена. Поскольку onCancelEncashment
     * и onConfirmEncashmentHide должны выполнятся синхронно
     * в той последовательности как идут события cancel-encashment
     * и hide модалки confirm-encashment-modal
     */
    onCancelEncashment() {
      this.isWasCancelEncashment = true
      this.cancelLastEncashment(this.finalEncashment.encashment_id)
      .then(() => {
        this.isWasCreateEncashment = false
      })
      .catch(() => {
        this.isWasCancelEncashment = false
        this.$refs['confirm-encashment-modal'].show()
      })
    },
    onConfirmEncashmentHide() {
      if (!this.isWasCancelEncashment) {
        this.isWasCreateEncashment = false
        this.$refs['create-encashment-modal'].hide()
      } else {
        this.isWasCancelEncashment = false
      }
    },
    onFileUpload(event) {
      if (event.target.files.length) {
        const formData = new FormData()
        formData.append('upload', event.target.files[0])
        this.updloadPhoto(formData)
      }
    }
  }
}